import { Component, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { BehaviorSubject, Observable } from 'rxjs';
import { NotificationContext, NotificationsListComponent } from '../notifications-list/notifications-list.component';
import { SidenavContentRef } from '../../shared/sidenav/sidenav-content/sidenav-content-ref';
import { SidenavContentModule } from '../../shared/sidenav/sidenav-content/sidenav-content.module';
import { DatabaseNotification } from 'app/models/entities/database-notification';
import { NotificationsService } from 'app/services/notifications/notifications-service';

@Component({
    selector: 'app-notifications-sidenav',
    templateUrl: './notifications-sidenav.component.html',
    standalone: true,
    imports: [
        MatButtonModule,
        AsyncPipe,
        MatMenuModule,
        MatIconModule,
        NotificationsListComponent,
        SidenavContentModule,
    ],
})
export class NotificationsSidenavComponent implements OnInit
{
    notifications$: Observable<DatabaseNotification[]>;

    readonly context = NotificationContext.PMC;
    readonly saving$ = new BehaviorSubject<boolean>(true);

    constructor(
            private _sidenavRef: SidenavContentRef<NotificationsSidenavComponent>,
            private _notificationService: NotificationsService,
    ) {}

    ngOnInit() {
        this.notifications$ = this._notificationService.notifications$.asObservable();
        this.saving$.asObservable().subscribe({
            next: (loading) => {
                this._sidenavRef.loading = loading;
            },
        });
    }

    handleNotificationNavigation() {
        this._sidenavRef.close();
    }
}
